"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    cloudRequest: ()=>cloudRequest
});
const external_axios_namespaceObject = require("axios");
var external_axios_default = /*#__PURE__*/ __webpack_require__.n(external_axios_namespaceObject);
const env_js_namespaceObject = require("./plugins/env.js");
const env_header_js_namespaceObject = require("./plugins/env-header.js");
const jwt_js_namespaceObject = require("./plugins/jwt.js");
const locale_js_namespaceObject = require("./plugins/locale.js");
function cloudRequest(options) {
    var _options_plugins;
    const plugins = options ? null != (_options_plugins = options.plugins) ? _options_plugins : [] : [];
    const instance = external_axios_default().create(options);
    instance.plugin = {
        use (plugin) {
            const ids = [];
            const { request, response } = plugin;
            if (request) ids[0] = instance.interceptors.request.use(...request);
            if (response) ids[1] = instance.interceptors.response.use(...response);
            return ids;
        },
        eject (ids) {
            if (ids[0]) instance.interceptors.request.eject(ids[0]);
            if (ids[1]) instance.interceptors.response.eject(ids[1]);
        }
    };
    for (const plugin of plugins){
        const isArray = Array.isArray(plugin);
        const isString = 'string' == typeof plugin;
        if (!isArray && !isString) {
            instance.plugin.use(plugin);
            continue;
        }
        const name = Array.isArray(plugin) ? plugin[0] : plugin;
        const config = Array.isArray(plugin) ? plugin[1] : null;
        let realPlugin = null;
        if ('jwt' === name) realPlugin = (0, jwt_js_namespaceObject.jwtPlugin)(config);
        if ('i18n' === name || 'locale' === name) realPlugin = (0, locale_js_namespaceObject.localePlugin)(config);
        if ('env' === name) realPlugin = (0, env_js_namespaceObject.envPlugin)(config);
        if ('envHeader' === name) realPlugin = (0, env_header_js_namespaceObject.envHeaderPlugin)(config);
        if (realPlugin) instance.plugin.use(realPlugin);
    }
    return instance;
}
exports.cloudRequest = __webpack_exports__.cloudRequest;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "cloudRequest"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
